import takeScreenshotJpegBlob from './utils/screenCapture';
class Screenshot {
}
Screenshot.cropImage = (base64, { left, top, size: { width, height } }) => new Promise((resolve) => {
    const image = new Image();
    const canvas = document.createElement('canvas');
    const pixelRatio = window.devicePixelRatio;
    canvas.width = width * pixelRatio;
    canvas.height = height * pixelRatio;
    const ctx = canvas.getContext('2d');
    image.src = base64;
    ctx.drawImage(image, -left * pixelRatio, -top * pixelRatio);
    canvas.toBlob((blob) => {
        resolve(new File([blob], 'screenshot.png', { type: 'image/png' }));
    });
});
Screenshot.take = (element, method) => {
    if (method === 'userMedia')
        return Screenshot.withUserMedia();
    return Screenshot.withHtml2Canvas(element);
};
Screenshot.withUserMedia = () => new Promise((resolve, reject) => {
    takeScreenshotJpegBlob()
        .then((screenshot) => {
        resolve(URL.createObjectURL(screenshot));
    })
        .catch((err) => {
        reject(err);
    });
});
export default Screenshot;
